import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when component is mounted
  }, []);
  return (
    <Container>
      <div class="privacy_text">
        <h2>SparkPro Privacy Policy </h2>
        <h4>
          <b>Last Updated :</b> 26 February 2025
        </h4>
        <p>
          SparkPro (“we,” “us,” or “our”) respects your privacy and is committed
          to protecting your personal data. This Privacy Policy explains how we
          collect, use, store, and share your information when you use our
          platform.
        </p>
        <p>
          By signing up for SparkPro, you agree to the collection and use of
          your data as outlined in this policy.
        </p>

        <h4>1. Information We Collect </h4>
        <p>
          When you use SparkPro, we may collect the following types of
          information:
        </p>

        <h4>1.1 Information You Provide to Us </h4>
        <ul>
          <li>
             <b>Account Information </b> – Name, email address, phone number,
            business details, and payment information.{" "}
          </li>
          <li>
             <b> Proﬁle Information </b> – Qualiﬁcations, experience, location,
            and business description.
          </li>
          <li>
             <b> Customer Communications </b> – Messages exchanged with
            customers through SparkPro.
          </li>
        </ul>

        <p>2.1 To use SparkPro as an electrician, you must: </p>
        <ul>
          <li>Be at least 18 years old.</li>
          <li>
            Hold the necessary qualiﬁcations and insurance to perform electrical
            work in the UK.
          </li>
          <li>
            Provide accurate and up-to-date information during registration.
          </li>
        </ul>

        <h4>1.2 Information We Collect Automatically </h4>
        <ul>
          <li>
             <b> Device and Usage Data </b> – IP address, browser type, device
            information, and platform usage patterns.
          </li>
          <li>
             <b>Cookies and Tracking Technologies </b> – We use cookies to
            improve your experience and track website activity.
          </li>
        </ul>

        <h4>1.3 Information from Third Parties</h4>
        <ul>
          <li>
            If you apply for veriﬁcation, we may check publicly available
            databases or request credentials from certiﬁcation bodies.
          </li>
        </ul>

        <h4>2. How We Use Your Information </h4>
        <p>We use the collected information to:</p>
        <ul>
          <li>Provide and improve the SparkPro platform.</li>
          <li>Verify electricians’ credentials.</li>
          <li>Process payments and subscriptions.</li>
          <li>
            {" "}
            Facilitate communication between electricians and customers.{" "}
          </li>
          <li> Detect and prevent fraud or misuse of the platform. </li>
          <li> Comply with legal obligations. </li>
        </ul>

        <h4>3. How We Share Your Information </h4>
        <p>
          We do <b>not </b> sell your personal data. However, we may share it in
          the following circumstances:
        </p>

        <h4>3.1 With Customers</h4>
        <p>
          • Your public proﬁle (including name, business details, and
          qualiﬁcations) is visible to potential customers.
        </p>

        <h4>3.2 With Service Providers </h4>
        <p>
          • We work with third-party service providers for payment processing,
          hosting, and analytics.
        </p>

        <h4>3.3 For Legal Reasons</h4>
        <p>
          • We may share information if required by law, to prevent fraud, or to
          protect our users.
        </p>

        <h4>4. Data Security</h4>
        <p>
          We take reasonable security measures to protect your data. However, no
          method of online transmission is 100% secure, so we cannot guarantee
          absolute security.{" "}
        </p>

        <h4>5. Data Retention </h4>
        <p>
          We keep your data only as long as necessary to provide the service or
          comply with legal requirements. You may request account deletion, but
          some data may be retained for compliance purposes.
        </p>

        <h4>6. Your Rights</h4>
        <p>Under UK data protection laws, you have the right to: </p>
        <ul>
          <li> Access, update, or delete your personal data. </li>
          <li> Object to data processing for marketing purposes. </li>
          <li> Request a copy of your data. </li>
        </ul>
        <p>
          To exercise these rights, contact us at <b> <a style={{ textDecoration: "none" }} href="mailto: contact@sparkpro.app"> contact@sparkpro.app</a>. </b>{" "}
        </p>

        <h4>7. Cookies and Tracking Technologies </h4>
        <p>
          We use cookies to improve functionality and measure site performance.
          You can adjust cookie settings in your browser.
        </p>

        <h4>8. Third-Party Links </h4>

        <p>
          SparkPro may contain links to third-party websites. We are not
          responsible for their privacy practices.
        </p>

        <h4>9. Changes to This Policy </h4>
        <p>
          We may update this Privacy Policy from time to time. Any changes will
          be posted here, and continued use of SparkPro constitutes acceptance
          of the updated policy.
        </p>

        <h4>10. Contact Us</h4>

        <p>
          If you have any questions about this Privacy Policy, contact us at
          <a style={{ textDecoration: "none" }} href="mailto: contact@sparkpro.app"> contact@sparkpro.app</a>{" "}
        </p>
      </div>
    </Container>
  );
};

export default PrivacyPolicy;
